export default "__VITE_ASSET__65da10a6__"